import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../../../Component/CustomButton";

const EditRulesButton = ({
  toggleEditMode,
  isEditedMode,
  submitEditedData,
}) => {
  const { t } = useTranslation();

  const handleEdit = () => {
    toggleEditMode();
  };

  const handleSubmit = () => {
    submitEditedData();
  };

  return (
    <CustomButton 
      variant={isEditedMode ? "primary" : "secondary"} 
      onClick={isEditedMode ? handleSubmit : handleEdit}
    >
      {isEditedMode ? t("labels.common.submit") : t("labels.common.edit")}
    </CustomButton>


  );
};

export default React.memo(EditRulesButton);
